import { BOOTSTRAP_GET_ACCOUNTS_SUCCESS } from 'stash/store/bootstrapActions';
import { POST_ACCOUNT_BANK_ACCOUNT_SUCCESS } from 'stash/actions/api/buffet';

const bank_account = (state = {}, action) => {
	switch (action.type) {
		case POST_ACCOUNT_BANK_ACCOUNT_SUCCESS:
			return action.response.bank_account || {};
		case BOOTSTRAP_GET_ACCOUNTS_SUCCESS:
			if (action.response.accounts.length > 0) {
				const accountWithBank = action.response.accounts.find((account) => account.bank_account);
				return (accountWithBank && accountWithBank.bank_account) || {};
			}
			return action.response.accounts;
		default:
			return state;
	}
};

export default bank_account;
